export default "__VITE_ASSET__6f176a65__"